// features/queue/queueSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosinterceptor";

const queueListApi =
  "/test_get_workflow_queue";
const queueDetailsApi =
  "/test_get_workflow_queue_detail";
const queueRules =
  "/test_get_queue_rules";
const createQueueApi =
  "/test_create_workflow_queue";
const searchApi =
  "/test_search_workflow_queue";
const filterApi =
  "/test_workflow_queue_filter";
const deleteQueueRulesApi =
  "/test_delete_worklow_queue_rules";
const assignedCodersList =
  "/test_coder_assign_list";

// Async thunk to fetch queue list
export const fetchQueueList = createAsyncThunk(
  "queue/fetchQueueList",
  async ({ pageNumber, selectedStatus, selectedPriority }, thunkAPI) => {
    // console.log(selectedStatus,'sdvzdsv');
    
    try {
      const params = new URLSearchParams();
      if(pageNumber){
        params.append("page_number", pageNumber);
      }

      
       if (selectedStatus!== undefined) {
        params.append("is_active", selectedStatus);
      }
    

      if (selectedPriority) {
        params.append("priority", selectedPriority.toUpperCase());
      }

      const response = await axiosInstance.get(`${queueListApi}?${params.toString()}`);
      console.log(response,'asdfgh');
      
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error);
      // return thunkAPI.rejectWithValue(
      //   error.response?.data || "Failed to fetch queue list"
      // );
    }
  }
);


// Async thunk to fetch queue details
export const fetchQueueDetails = createAsyncThunk(
  "queue/fetchQueueDetails",
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${queueDetailsApi}?queue_id=${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue details"
      );
    }
  }
);
// Async thunk to fetch queue rules
export const fetchQueueRules = createAsyncThunk(
  "queue/fetchQueueRules",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(queueRules);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue details"
      );
    }
  }
);
// Async thunk to create a queue
export const createQueue = createAsyncThunk(
  "queue/createQueue",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(createQueueApi, payload); // <-- this sends the body
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to create queue"
      );
    }
  }
);
export const searchQueue = createAsyncThunk(
  "queue/searchQueue",
  async (searchTerm, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${searchApi}?search_term=${searchTerm}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to create queue"
      );
    }
  }
);
export const applyQueueFilters = createAsyncThunk(
  "queue/filterQueue",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(filterApi, payload);
     //console.log(response,'queuefil');
      
      const parsedBody = response.data.data;
      return parsedBody;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to create queue"
      );
    }
  }
);
export const deleteQueueRules = createAsyncThunk(
  "queue/deleteQueueRule",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(deleteQueueRulesApi, payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to create queue"
      );
    }
  }
);
export const assignedByList = createAsyncThunk(
  "queue/codersList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(assignedCodersList);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to create queue"
      );
    }
  }
);
const queueSlice = createSlice({
  name: "queue",
  initialState: {
    queueListData: [],
    queueDetailsData: [],
    queueRules: [],
    queuesList: [],
    searchedData: [],
    filteredQueueData: [],
    deletedQueueData: [],
    codersList: [],
    loadingList: false,
    loadingQueueDetails: false,
    loadingQueueRules: false,
    loadingQueueCreation: false,
    loadingQueueSearch: false,
    loadingFilteredData: false,
    loadingDeletedData:false,
    errorList: null,
    errorDetails: null,
  },
  reducers: {
    clearFilteredQueueData: (state) => {
      state.filteredQueueData = [];
    },
    clearSearchedData(state) {
      state.searchedData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Queue List
      .addCase(fetchQueueList.pending, (state) => {
        state.loadingList = true;
        state.errorList = null;
      })
      .addCase(fetchQueueList.fulfilled, (state, action) => {
        state.loadingList = false;
        state.queueListData = action.payload;
      })
      .addCase(fetchQueueList.rejected, (state, action) => {
        state.loadingList = false;
        state.errorList = action.payload;
      })

      // Fetch Queue Details
      .addCase(fetchQueueDetails.pending, (state) => {
        state.loadingQueueDetails = true;
        state.errorDetails = null;
      })
      .addCase(fetchQueueDetails.fulfilled, (state, action) => {
        state.loadingQueueDetails = false;
        state.queueDetailsData = action.payload;
      })
      .addCase(fetchQueueDetails.rejected, (state, action) => {
        state.loadingQueueDetails = false;
        state.errorDetails = action.payload;
      })

      // Fetch Queue Rules
      .addCase(fetchQueueRules.pending, (state) => {
        state.loadingQueueRules = true;
        state.errorDetails = null;
      })
      .addCase(fetchQueueRules.fulfilled, (state, action) => {
        state.loadingQueueRules = false;
        state.queueRules = action.payload;
      })
      .addCase(fetchQueueRules.rejected, (state, action) => {
        state.loadingQueueRules = false;
        state.errorDetails = action.payload;
      })

      // Create Queue
      .addCase(createQueue.pending, (state) => {
        state.loadingQueueCreation = true;
        state.errorDetails = null;
      })
      .addCase(createQueue.fulfilled, (state, action) => {
        state.loadingQueueCreation = false;
        state.createQueue = action.payload;
      })
      .addCase(createQueue.rejected, (state, action) => {
        state.loadingQueueCreation = false;
        state.errorDetails = action.payload;
      })

      // Search Queue
      .addCase(searchQueue.pending, (state) => {
        state.loadingQueueSearch = true;
        state.errorDetails = null;
      })
      .addCase(searchQueue.fulfilled, (state, action) => {
        state.loadingQueueSearch = false;
        state.searchedData = action.payload;
      })
      .addCase(searchQueue.rejected, (state, action) => {
        state.loadingQueueSearch = false;
        state.errorDetails = action.payload;
      })

      // Filter Queue
      .addCase(applyQueueFilters.pending, (state) => {
        state.loadingFilteredData = true;
        state.errorDetails = null;
      })
      .addCase(applyQueueFilters.fulfilled, (state, action) => {
        state.loadingFilteredData = false;
        state.filteredQueueData = action.payload;
      })
      .addCase(applyQueueFilters.rejected, (state, action) => {
        state.loadingFilteredData = false;
        state.errorDetails = action.payload;
      })
      // delete Queue rule
      .addCase(deleteQueueRules.pending, (state) => {
        state.loadingDeletedData = true;
        state.errorDetails = null;
      })
      .addCase(deleteQueueRules.fulfilled, (state, action) => {
        state.loadingDeletedData = false;
        state.deletedQueueData = action.payload;
      })
      .addCase(deleteQueueRules.rejected, (state, action) => {
        state.loadingDeletedData = false;
        state.errorDetails = action.payload;
      })
      // get coders list
      .addCase(assignedByList.pending, (state) => {
        state.loadingCodersData = true;
        state.errorDetails = null;
      })
      .addCase(assignedByList.fulfilled, (state, action) => {
        state.loadingCodersData = false;
        state.codersList = action.payload;
      })
      .addCase(assignedByList.rejected, (state, action) => {
        state.loadingCodersData = false;
        state.errorDetails = action.payload;
      });
  },
});

export const { clearFilteredQueueData,clearSearchedData, } = queueSlice.actions;

export default queueSlice.reducer;
